<template>
  <div class="LmBreadcrumbSummary truncate">
    <span class="Circle" :class="'text-' + color" />
    <ul class="truncate">
      <router-link
        v-for="(item, i) in breadcrumb"
        :key="`${item.name}-${i}`"
        tag="li"
        :to="{params: {actor: item.pathArr}, query: $route.query}"
        >{{ item.name }}</router-link
      >
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LmBreadcrumbSummary',
  props: {
    breadcrumb: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.LmBreadcrumbSummary {
  display: flex;
  align-items: flex-start;
  ul {
    font-size: 13px;
    line-height: 1.3;
    color: theme('colors.gray.700');
  }
  li {
    display: inline;
    cursor: pointer;
    &:after {
      content: '/';
      margin: 0 4px;
      font-size: 12px;
    }
    &:last-child:after {
      content: none;
    }
    &:hover {
      color: black;
      &:after {
        color: theme('colors.gray.700');
      }
    }
  }
}
.Circle {
  display: inline-flex;
  &:before {
    content: '';
    flex: none;
    width: 16px;
    height: 16px;
    margin-right: 12px;
    border: 2px solid;
    border-radius: 9999px;
  }
}
</style>
